<template>
  <div
    class="container columns flex-row-md cwh-container col-gapless ai-c jc-c"
  >
    <div class="content column">
      <div class="event row flex flex-fw col-12">
        <div class="row flex ai-c text-center flex-column col-12">
          <h1 class="subheader roboto">Our Events</h1>
          <h2 class="mainheader" v-if="events.length < 1">
            Stay tuned for future events!
          </h2>
          <h2 v-if="events.length >= 1" class="mainheader">
            Coding for Cookies
          </h2>
        </div>
        <p v-if="events.length < 1">
          <a
            id="newsletterEventsSignup"
            class="button primary"
            href="https://mailchi.mp/3030d598d5fe/codewithher_signup"
            target="_blank"
          >
            <span class="underline">Sign up for updates</span>
          </a>
        </p>
        <div
          class="row flex flex-fw col-12"
          v-for="event in events"
          :key="event.title"
        >
          <div class="column assets col-12 col-md-6 text-center">
            <img :src="require(`@/assets/${event.img}`)" :alt="event.title" />
            <div class="cta" v-if="event.tagline">
              <a
                target="_blank"
                :href="event.link"
                class="button primary events-event__link events--current"
              >
                <span class="underline">{{ event.tagline }}</span>
              </a>
            </div>
          </div>
          <div class="column details col-12 col-md-6">
            <div class="stats flex">
              <span class="stat stat-user column">
                <span class="stat-title">
                  <i class="fas fa-users" alt="Troop Levels"></i>
                  <span class="stat-label">Age Level</span>
                </span>
                <span class="stat-detail age">{{ event.age }}</span>
              </span>
              <span
                v-if="event.badges.length >= 1"
                class="stat stat-badges column"
              >
                <span class="stat-title">
                  <i class="fas fa-trophy" alt="Badges"></i>
                  <span class="stat-label">GS Badges (optional)</span>
                </span>
                <span
                  v-for="badge in event.badges"
                  :key="badge.title"
                  class="stat-badge-titles"
                >
                  <span class="stat-detail badge-title">{{ badge.title }}</span>
                </span>
              </span>
              <span class="stat stat-dates column">
                <span class="stat-title">
                  <i class="fas fa-calendar" alt="Event Date(s)"></i>
                  <span class="stat-label">Dates</span>
                </span>
                <span class="stat-detail dates">{{ event.dates }}</span>
              </span>
              <span class="stat stat-duration column">
                <span class="stat-title">
                  <i class="fa fa-clock" alt="Duration"></i>
                  <span class="stat-label">Duration</span>
                </span>
                <span class="stat-detail duration">{{ event.duration }}</span>
              </span>
              <span class="stat event-cost column">
                <span class="stat-title">
                  <i class="fa fa-dollar-sign" alt="Price"></i>
                  <span class="stat-label">Price</span>
                </span>
                <span class="stat-detail price">{{ event.cost }}</span>
              </span>
              <span class="stat event-location column">
                <span class="stat-title">
                  <i class="fa fa-map-pin" alt="Location"></i>
                  <span class="stat-label">Location</span>
                </span>
                <span class="stat-detail price">{{ event.location }}</span>
              </span>
            </div>
          </div>
          <div class="column desc">
            <span class="stat-title">
              <br />
              <h2 class="desc-header">Event Description</h2>
            </span>
            <div class="events-desc" v-html="event.desc"></div>
            <br />
            <a
              target="_blank"
              :href="event.link"
              class="button primary events-event__link events--current"
            >
              <span class="underline">{{ event.tagline }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EventListings",
  data() {
    return {
      events: [
        {
          age: "8yrs - 14yrs (Brownies - Cadettes)",
          badges: [
            {
              title: "Coding for Good",
            },
            {
              title: "Cookie Business",
            },
          ],
          duration: "3+hrs",
          dates: "11/15/2022 - 6/30/2023",
          cost: "$25/participant, $5 discount for returning or groups of 6+",
          desc:
            '<p>This DIY coding project is back for the third year in a row, and better than ever, with badges to earn and goals to showcase! Girl Scouts will use technology to create and code their very own virtual sales pitch-- it can be sent to friends, relatives & community members via email or social media. A QR code will direct your cookies customers to their online ordering sheet, complete with About Me, Cookies & Cost and Personal Sales Goals.</p><p><strong>In this self - guided project Girl Scouts will learn:</strong><ul><li>How to create a virtual sales pitch.</li><li>How to use the <a :href="https://scratch.mit.edu/" target="_blank">Scratch</a> coding platform for this project and how to create your own coding projects in the future. </li><li>Basic coding concepts to animate your project, including: Prototyping, Algorithms, User Events, Loops and Conditional Statements </li><li><strong>Added bonus!</strong> You will earn the following badges: 3 Coding for and 2 Cookie Business Badges</li></ul></p><h3>Program Levels: Brownies, Juniors, and Cadettes</h3><p>This project is designed for students ages 8 - 14. Don\'t be intimidated by not knowing how to code-- you\'re here to learn and we are here with step by step instructional videos and instructions. We will have two projects available for each program level: “Beginner Level” and “Experienced Level”.</p><p><strong>Beginner Level:</strong> This project is perfect for you if you are brand-new to Scratch, or if you have used Scratch before but still need some guidance. This level will include video-recorded step-by-step coding instructions.</p><p><strong>Experienced Level:</strong> Select this level if you\'re comfortable with building Scratch projects on your own with little to no guidance. We suggest Cadettes start here!</p><h3>Girl Scout Badges:</h3><p>Your Girl Scout will complete all requirements and earn the following badges with Coding for Cookies:</p><ul class="flex-lg"> <li class="column col-12 col-lg-4"><strong>Brownies</strong> <ul> <li>Coding for Good</li><ul> <li> Coding Basics </li><li> Digital Game Design </li><li> App Development </li></ul> </ul> <ul> <li>Cookie Business</li><ul> <li> Cookie Decision Maker </li><li> My Cookie Customers </li></ul> </ul> </li><li class="column col-12 col-lg-4"><strong>Juniors</strong> <ul> <li>Coding for Good</li><ul> <li> Coding Basics </li><li> Digital Game Design </li><li> App Development </li></ul> </ul> <ul> <li>Cookie Business</li><ul> <li> Cookie Collaborator </li><li> My Cookie Team </li></ul> </ul> </li><li class="column col-12 col-lg-4"><strong>Cadettes</strong> <ul> <li>Coding for Good</li><ul> <li> Coding Basics </li><li> Digital Game Design </li><li> App Development </li></ul> </ul> <ul> <li>Cookie Business</li><ul> <li> Master Your Cookie Business </li><li> Cookie Innovator </li></ul> </ul> </li></ul><p><em>Please note: Badges are not included in price, and can be purchased through Girl Scouts after the project is completed.</em></p><h3>Code With Her Patch</h3><p>To earn your Code With Her fun patch, you will need to take a survey with your Girl Scout after they\'ve completed the project. Code With Her will mail the patch when received.</p><h3>Time Commitment: 3+ Hours</h3><p>This project is designed to be girl led and self-guided, to ensure participants are able to go at their own pace. This means the project may take longer, and that\'s okay!</p><h3>Troop Discount</h3><p><span class="class="highlight">$5 off per participant!</span> When purchasing 6 or more tickets, you will receive a discounted rate of $20 per Girl Scout.</p><p><h3>We use Google Classroom for our DIY projects.</h3> You will need a Gmail account to use Google Classroom. <em>Note that Google/Gmail accounts created by your school or work may not be able to access our Google Classroom due to permissions set by your IT Administrators. All Gmail accounts ending in @gmail.com will work.</em></p><h3>We believe that everyone should have access to tech opportunities!</h3><p>If you are unable to participate because of cost, please email support@codewithher.org and request to participate through our Opportunity Fund.</p><p>Code With Her has an “On Your Honor” system for our program materials-- we ask that you respect the hard work & creativity our team has put into this DIY project by not sharing it with others.</p><p><h3>Questions?</h3>If you would like more information or have any questions, please feel free to reach out to support@codewithher.org.</p>',
          img: "c4c-2022.jpg",
          link:
            "https://fareharbor.com/embeds/book/codewithher/items/256279/availability/1030703489/book/?full-items=yes",
          location: "Google Classroom",
          tagline: "Purchase Access",
          title: "Coding for Cookies",
        },
      ],
      archive: [
        {
          age: "Brownies and Juniors",
          badges: [
            {
              title: "Robotics Badges (3)",
            },
            {
              title: "Entertainment Technology (Juniors)",
            },
          ],
          duration: "~8-10hrs",
          dates: "07/05/2022 - 11/01/2022",
          cost: "$25/participant",
          desc:
            '<p><strong>Code with Mitzy</strong> is a self guided coding project that is created in collaboration with <a class="events-schedule__link" :href="https://mitzymakesit.com/" target="_blank">Mitzy Makes It</a> and Code With Her. This three part summer project that will keep your kids engaged and having fun over the summer!</p><p><strong>In this self - guided project you will:</strong> <ul> <li>Code and animate part of our Code With Mitzy video</li><li>Design your own animated character</li><li>Learn basic coding concepts to animate your project, including: Prototyping, Algorithms, User Events, Loops and Conditional Statements </li><li>Learn how to use the <a class="events-schedule__link" :href="http://scratch.mit.edu" target="_blank">Scratch</a> coding platform to create your own coding projects in the future. </li><li><strong>Added bonus!</strong> If you are a Girl Scout, you will earn the follow badges: Robotics Badges (Brownie/Junior) and Entertainment Technology (Junior) <ul> <li>Just FYI: Robotics is 3 badges, they are: (1) Programming Robots (2) Designing Robots (3) Showcasing Robots</li></ul> </li></ul></p><p><strong>Appropriate for ages 8+ with limited support from an adult.</strong> Don\'t be intimidated by not knowing how to code-- you\'re here to learn and we are here with step by step instructional videos. </p><p>This is perfect for you if you are brand-new to Scratch, or if you have used Scratch before but still need some guidance. This level will include video-recorded step-by-step coding instructions.</p><p>This project has three parts, and should take around <strong>8 - 10 hours</strong> total from start to finish. Because it is student led and self-guided, participants will be able to go at their own pace. <em>Please note this project may take longer, and that\'s okay!</em></p><p><strong>We use Google Classroom for our DIY projects.</strong>You will need a Gmail account to use Google Classroom. Note that Google/Gmail accounts created by your school or work may not be able to access our Google Classroom due to permissions set by your IT Administrators. <strong>All Gmail accounts ending in @gmail.com will work</strong>. </p><p><strong>Girl Scouts will earn the following badges</strong>: Robotics Badges (Brownie/Junior) and Entertainment Technology (Juniors). </p><p>\'Code With Her\' and \'Mitzy Makes It\' has an “On Your Honor” system for our program materials-- we ask that you respect the hard work & creativity our team has put into this DIY project by not sharing it with others. </p><p><strong>We believe that everyone should have access to tech opportunities!</strong> If you are unable to participate because of cost, please email <a class="events-schedule__link" :href="mailto:support@codewithher.org">support@codewithher.org</a> and request for an Opportunity Fund.</p><p>If you have any questions, please feel free to reach out to <a class="events-schedule__link" :href="mailto:support@codewithher.org">support@codewithher.org</a></p>',
          img: "mitzy-2022.jpg",
          link:
            "https://fareharbor.com/embeds/book/codewithher/items/385681/availability/936989455/book/?full-items=yes",
          location: "Google Classroom.",
          tagline: "Purchase Access",
          title: "Coding With Mitzy",
        },
        {
          age: "Brownies - Cadettes",
          badges: [
            {
              title: "Coding for Good",
            },
            {
              title: "Cookie Business",
            },
          ],
          duration: "3+hrs",
          dates: "12/15/2021 - 6/30/2022",
          cost: "$25/participant, $5 discount for returning or groups of 6+",
          desc:
            '<p>This DIY coding project is back for the second year in a row, and better than ever, with new badges to earn and goals to showcase! Girl Scouts will use technology to create and code their very own virtual sales pitch-- it can be sent to friends, relatives & community members via email or social media. A QR code will direct your cookies customers to their online ordering sheet, complete with About Me, Cookies & Cost and Personal Sales Goals.</p><p>In this self - guided project Girl Scouts will learn:<ul><li>How to create a virtual sales pitch.</li><li>How to use the <a :href="https://scratch.mit.edu/" target="_blank">Scratch</a> coding platform for this project and how to create your own coding projects in the future. </li><li>Basic coding concepts to animate your project, including: Prototyping, Algorithms, User Events, Loops and Conditional Statements </li><li><strong>Added bonus!</strong> You will earn the following badges: 3 Coding for and 2 Cookie Business Badges (new this year!)</li></ul></p><h3>Program Levels: Brownies, Juniors, and Cadettes</h3><p>This project is designed for students ages 8 -14. Don\'t be intimidated by not knowing how to code-- you\'re here to learn and we are here with step by step instructional videos and instructions. We will have two projects available for each program level: “Beginner Level” and “Experienced Level”.</p><p></p><strong>Beginner Level:</strong> This project is perfect for you if you are brand-new to Scratch, or if you have used Scratch before but still need some guidance. This level will include video-recorded step-by-step coding instructions.</p><p></p><strong>Experienced Level:</strong> Select this level if you\'re comfortable with building Scratch projects on your own with little to no guidance. We suggest Cadettes start here!</p><h3>Girl Scout Badges:</h3><p>Your Girl Scout will complete all requirements and earn the following badges with Coding for Cookies:</p><ul class="flex-lg"> <li class="column col-12 col-lg-4"><strong>Brownies</strong> <ul> <li>Coding for Good</li><ul> <li> Coding Basics </li><li> Digital Game Design </li><li> App Development </li></ul> </ul> <ul> <li>Cookie Business</li><ul> <li> Cookie Decision Maker </li><li> My Cookie Customers </li></ul> </ul> </li><li class="column col-12 col-lg-4"><strong>Juniors</strong> <ul> <li>Coding for Good</li><ul> <li> Coding Basics </li><li> Digital Game Design </li><li> App Development </li></ul> </ul> <ul> <li>Cookie Business</li><ul> <li> Cookie Collaborator </li><li> My Cookie Team </li></ul> </ul> </li><li class="column col-12 col-lg-4"><strong>Cadettes</strong> <ul> <li>Coding for Good</li><ul> <li> Coding Basics </li><li> Digital Game Design </li><li> App Development </li></ul> </ul> <ul> <li>Cookie Business</li><ul> <li> Master Your Cookie Business </li><li> Cookie Innovator </li></ul> </ul> </li></ul><p><em>Please note: Badges are not included in price, and can be purchased through Girl Scouts after the project is completed.</em></p><h3>Code With Her Patch</h3><p>To earn your Code With Her fun patch, you will need to take a survey with your Girl Scout after they\'ve completed the project. Code With Her will mail the patch when received. </p><h3>Time Commitment: 3+ Hours</h3><p>This project is designed to be girl led and self-guided, to ensure participants are able to go at their own pace. This means the project may take longer, and that\'s okay!</p><p class="highlight"><strong>Discounts - $5 off per participant!</strong></p><ul><li><strong>Troop</strong>: When purchasing 6 or more tickets, you will receive a discounted rate of $20 per Girl Scout. </li><li><strong>Returning Participant</strong>: Check your email to receive a special code to receive a discounted rate of $20 for all Girl Scouts who participated in our program last year. </ul><p><strong>We use Google Classroom for our DIY projects.</strong> You will need a Gmail account to use Google Classroom. Note that Google/Gmail accounts created by your school or work may not be able to access our Google Classroom due to permissions set by your IT Administrators. All Gmail accounts ending in @gmail.com will work. </p><p><strong>We believe that everyone should have access to tech opportunities!</strong> If you are unable to participate because of cost, please email support@codewithher.org and request to participate through our Opportunity Fund.</p><p>Code With Her has an “On Your Honor” system for our program materials-- we ask that you respect the hard work & creativity our team has put into this DIY project by not sharing it with others.</p><p><h3>Questions?</h3>If you would like more information or have any questions, please feel free to reach out to support@codewithher.org.</p>',
          img: "c4c_square.jpg",
          link:
            "https://fareharbor.com/embeds/book/codewithher/items/256279/availability/805754127/book/?full-items=yes",
          location: "Google Classroom. Access available until 04/30/2021",
          tagline: "Purchase Access",
          title: "Coding for Cookies",
        },
        {
          age: "8+",
          badges: [
            {
              title: "Robotics Badge (Brownie/Junior)",
            },
            {
              title: "Entertainment Technology (Junior)",
            },
          ],
          duration: "~8-10hrs",
          dates: "6/21/2021 - 9/30/2021",
          cost: "$25/participant",
          desc:
            '<p><strong>Help get Mitzy ready for her summer party through coding and animation!</strong></p><p><strong>Code With Mitzy</strong> is a self guided coding project that is created in collaboration with <a href="https://mitzymakesit.com/" target="_blank" rel="nofollow noopener noreferrer">Mitzy Makes It</a> and <a href="https://www.codewithher.org" target="_blank" rel="nofollow noopener noreferrer">Code With Her</a>. This three part summer  project that will keep your kids engaged and having fun over the summer! </p><p>Watch Mitzy\'s Happy First Day of Summer video on YouTube here: <a href="https://www.youtube.com/watch?v=fMVyBZZZqQM" target="_blank" rel="nofollow noopener noreferrer">https://www.youtube.com/watch?v=fMVyBZZZqQM</a></p><p>We will be learning how to create a part of the video in this project. </p><p><strong>In this self - guided project you will:</strong></p><ul><li>Code and animate part of our Code With Mitzy video</li><li>Design your own animated character</li><li>Learn basic coding concepts to animate your project, including: Prototyping, Algorithms, User Events, Loops  and Conditional Statements </li><li>Learn how to use the <a href="http://scratch.mit.edu" target="_blank" rel="nofollow noopener noreferrer">Scratch</a> coding platform to create your own coding projects in the future. </li><li><strong>Added bonus!</strong> If you are a Girl Scout, you will earn the following badges: <strong> Robotics Badges </strong>(Brownie/Junior) and <strong> Entertainment Technology </strong>(Junior). Robotics is 3 badges combined, they are: (1) Programming Robots (2) Designing Robots (3) Showcasing Robots</li></ul><p><strong>Appropriate for ages 8+ with limited support from an adult.</strong>  Don\'t be intimidated by not knowing how to code-- you\'re here to learn and we are here with step by step instructional videos. We will have two projects available “Beginner Level” and “Experienced Level” </p><p><strong>Beginner Level: </strong>This level is perfect for you if you are brand-new to Scratch, or if you have used Scratch before but still need some guidance. This level will include video-recorded step-by-step coding instructions.</p><p><strong>Experienced Level:</strong> Select this level if you\'re comfortable with building Scratch projects on your own with little to no guidance. This level includes instructions to help you along the way. </p><p>This project has three parts, and should take around<strong> 8 - 10 hours total </strong>from start to finish. Because it is student led and self-guided, participants will be able to go at their own pace.  <em>Please note this project may take longer, and that\'s okay! </em></p><p><strong>We use the platform Google Classroom for our DIY projects. </strong></p><p>You will need a Gmail account to use Google Classroom. <em>Note that Google/Gmail accounts created by your school or work may not be able to access our Google Classroom due to permissions set by your IT Administrators. </em><strong><em>All Gmail accounts ending in @gmail.com will work. </em></strong></p><p>‘Code With Her\' and ‘Mitzy Makes It\'  have an “On Your Honor” system for our program materials-- we ask that you respect the hard work &amp; creativity our team has put into this DIY project by not sharing it with others. </p><p><strong>We believe that everyone should have access to tech opportunities! </strong>If you are unable to participate because of cost, please email <a href="mailto:support@codewithher.org">support@codewithher.org</a> to request assistance through our opportunity fund.</p><p>If you have any questions, please feel free to reach out to <a href="mailto:support@codewithher.org"><strong>support@codewithher.org</strong></a>.</p><p></p>',
          eb_id: 160102600187,
          img: "mitzy_hero.jpg",
          link:
            "https://www.eventbrite.com/e/code-with-mitzy-tickets-160102600187?aff=ebdsoporgprofile",
          location: "Google Classroom. Access available until 12/31/2021",
          tagline: "Buy Tickets",
          title: "Code with Mitzy",
          videos: [
            {
              title: "Code with Mitzy!",
              src: "fMVyBZZZqQM",
            },
          ],
        },
        {
          age: "All Levels",
          badges: [
            {
              title: "Coding for Good Badges 1-3",
            },
          ],
          duration: "~2hrs",
          dates: "1/16/2021 - 3/31/2021",
          cost: "$11-12.50/participant",
          desc:
            '<p>This DIY Coding project, and Coding For Good 3 badge workshop, has been created and recorded by the Code With Her Team, with help from their Cadette &amp; Junior Girl Scout friends Gabi &amp; Nishka! Here are our sample projects for <a class="events-schedule__link " href="https://drive.google.com/file/d/1AHZsbe4TzI3TT8FPfCXNlOggZDf_rbRX/view?usp=sharing" target="_blank" rel="nofollow noopener noreferrer">Little Brownie Bakers </a>and <a class="events-schedule__link" href="https://drive.google.com/file/d/1m4IZZDk4GErq1-OrUZDuCNzRcUwGlk3Q/view?usp=sharing" target="_blank" rel="nofollow noopener noreferrer">ABC Bakers</a>.</p><p>Girl Scouts use technology to create and code their very own virtual sales pitch-- it can be sent to friends, relatives &amp; community members via email or social media. A QR code will direct your cookies customers to their online ordering sheet, complete with About Me, Cookies &amp; Cost and Personal Sales Goals. </p><p>As an added bonus, completing this DIY project also <strong>fulfills the requirements for all three </strong><a class="events-schedule__link" href="https://www.girlscoutshop.com/search?keywords=coding%20for%20good" target="_blank" rel="nofollow noopener noreferrer"><strong>Coding for Good</strong></a><strong> Badges: </strong>Coding Basics, Digital Game Design &amp; App Development! <strong>Badges can be purchased through Girl Scouts after the workshop is completed. </strong></p><p>This is a marketing project for Girl Scout cookie sales, a 3 badge workshop and a Scratch tutorial all in one! </p><p><strong>In this self - guided project you will learn:</strong></p><p>To create a virtual sales pitch.</p><p>How to use the Scratch coding platform to create your own coding projects </p><p>Basic coding concepts to animate your objects, including:</p><ul><li>Algorithms</li><li>User Events</li><li>Loops </li><li>Motion </li></ul><p>To create a scannable QR code</p><p>How to be a digital entrepreneur! </p><p>Plus, fulfill the requirements for Coding for Good Badges 1 through 3!</p><p><strong>Appropriate for all ages with support from an adult</strong>, this project is beginner friendly! Don\'t be intimidated by not knowing how to code-- you\'re here to learn! </p><p>This project should take around 2+ hours from start to finish. Because it is girl led and self-guided, girls will be able to go at their own pace.  Your access to Google Classroom will remain active for a month after access date. You\'ll also need a gmail account to use Google Classroom-- so best to sign up right away with your personal Gmail address! Note that Google/Gmail accounts created by your school or work may not be able to access our Google Classroom due to permissions set by your IT Administrators. All Gmail accounts ending in @gmail.com will work. </p<p>Code With Her has an “On Your Honor” system for our program materials-- we ask that you respect the hard work &amp; creativity our team has put into this DIY project by not sharing it with others. <strong>If someone is unable to access the DIY project, please have them reach out and ask about our Opportunity Fund! </strong></p><p><em>*If you are a </em><em><strong>Troop Leader</strong></em><em> purchasing for your Girl Scout Troop, please select the “group member” option and either send the link to your Girl Scout\'s parents or add their email addresses to your group page. We will need an individual email address for each DIY Project Participant to add them to the Google Classroom. </em></p><p>If you have any questions, please feel free to reach out to <a class="events-schedule__link" href="mailto:cookies@codewithher.org">cookies@codewither.org.</a></p>',
          eb_id: 136551861293,
          img: "coding_cookies.jpeg",
          link:
            "https://www.eventbrite.com/e/girl-scouts-coding-for-cookies-tickets-136551861293",
          location: "Google Classroom",
          tagline: "Tickets",
          title: "Coding for Cookies",
          videos: [
            {
              title: "Little Brownie Bakers Example",
              src: "5DvNpCzP6T8",
            },
            {
              title: "ABC Bakers Example",
              src: "BJOdHCSipnY",
            },
          ],
        },
        {
          age: "All Levels",
          badges: [
            {
              title: "Coding Together",
            },
          ],
          duration: "~2hrs",
          dates: "4/23/2021 - 5/31/2021",
          cost: "$10-12/participant",
          desc: "",
          eb_id: 136912600273,
          img: "motherday.jpg",
          link:
            "https://www.eventbrite.com/e/girl-scouts-coding-together-mothers-day-tickets-136912600273",
          location: "Google Classroom",
          tagline: "Tickets",
          title: "Coding Together - Mothers Day",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.cwh-container {
  padding: 0 1rem;

  .content {
    padding-top: 0;
  }
}

.event {
  background: #fff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  margin-bottom: 3.2rem;
  padding: 2rem 0;

  @media (min-width: $size-lg) {
    padding: 2rem;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  .event-headers {
    @media (max-width: $size-lg) {
      flex-direction: column;
    }
  }

  .event-header--subtitle {
    font-size: $unit-4;
    padding-bottom: 0.4rem;
    text-transform: uppercase;

    .event-logo {
      margin-right: 0.5rem;
      max-width: 2rem;
    }

    @media (min-width: $size-md) {
      font-size: $unit-5;
    }
  }

  .event-header {
    font-size: 1.25rem;
    margin: 0 0 2rem;

    @media (min-width: $size-md) {
      font-size: 1.5rem;
    }
  }

  .column {
    flex: 1 0 auto;

    @media (min-width: $size-lg) {
      &.assets {
        order: 1;
        text-align: center;
        margin-bottom: 1rem;
      }
      &.details {
        margin-bottom: 1.5rem;
        order: 2;
        padding-left: 3rem;

        .events-desktop {
          margin: 1rem 0;
        }
      }
      &.desc {
        order: 5;
      }
      &.videos {
        order: 4;
        margin-bottom: 2rem;

        iframe {
          height: auto;
          min-height: 400px;
        }
      }
    }
  }

  .events-header--event-stats {
    margin: 0 0 1rem;

    @media (min-width: $size-md) {
      justify-content: flex-start;
    }
  }

  .event-cta {
    margin-top: 1rem;
  }

  .event-body {
    p {
      line-height: 1.75;
      margin-top: 0;
    }
  }

  .stats {
    padding: 0 1rem;
    flex-wrap: wrap;

    @media (min-width: $size-md) {
      align-items: flex-start;
    }
  }

  .stat {
    padding: 0 0 1rem;

    @media (min-width: $size-md) {
      font-size: 1rem;

      &:last-of-type {
        margin-right: 0;
      }

      &:first-of-type,
      &:nth-of-type(1n + 2) {
        padding-right: 1rem;
      }
    }

    .stat-detail {
      display: block;
    }
  }

  .events-schedule__link {
    color: $dark-color;
    text-decoration: underline;
  }

  .events-schedule {
    @media (max-width: $size-max-sm) {
      flex-direction: column;
    }

    a {
      color: $dark-color;
    }

    .column {
      @media (max-width: $size-max-sm) {
        margin-bottom: 2rem;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .events-schedule__header {
      margin-top: 0;
    }

    .events-schedule__link {
      cursor: pointer;
      display: block;
      margin-bottom: 0.5rem;

      .fa-arrow-right {
        margin-left: 1rem;
        position: relative;
        right: 0;
        transition: all 0.3s;
      }

      &:hover {
        .fa-arrow-right {
          right: -5px;
        }
      }
    }
  }

  .desc {
    padding: 0 1rem;
  }

  .desc-header {
    margin: 2rem 0 0;
  }

  .events-desc {
    ul {
      padding-inline-start: 2rem;
    }

    li {
      list-style-type: inherit;
      padding: 0.5rem 0;
    }

    a {
      color: $dark-color;
    }

    h3 {
      margin-top: 3rem;
    }
  }
}

.cta {
  flex: 1 0 100%;
  font-size: 1rem;
  margin-bottom: 1rem;
  max-width: 100%;
  text-align: center;

  @media (max-width: $size-max-md) {
    background: #fff;
    border-top: 1px solid $dark-color;
    bottom: 0;
    left: 0;
    margin: 0;
    padding: $unit-5;
    position: fixed;
    right: 0;
    z-index: 99;

    .button {
      margin: 0;
    }
  }
}

.stat-label {
  font-size: 1rem;
  margin-left: 0.5rem;
}

.stat-title {
  align-items: center;
  border: solid $secondary-color;
  border-width: 0 0 1px;
  display: flex;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0.5rem 0.5rem 0;
}

.events-event__link {
  margin: 2rem 0;
  width: 100%;

  @media (min-width: $size-lg) {
    margin: 0;
  }
}

.highlight {
  color: $secondary-color;
}

.youtube-image {
  max-width: 600px;
}
</style>
